import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "game-page" }
const _hoisted_2 = { class: "toolbar" }
const _hoisted_3 = { class: "flex gap-5 items-center" }
const _hoisted_4 = { class: "flex gap-2" }
const _hoisted_5 = ["onClick", "title"]
const _hoisted_6 = { class: "flex gap-5 text-sm text-gray-600" }
const _hoisted_7 = { class: "info" }
const _hoisted_8 = { class: "text-[11px] bg-gray-50 border border-gray-200 rounded p-2 max-h-[48vh] overflow-auto leading-tight" }

import { computed, onMounted, onUnmounted } from 'vue'
import { game } from '../game/init'
import GridPane from './GridPane.vue'
import Explainer from './explainer/Explainer.vue'
import { useSaveSlots } from './useSaveSlots'


export default /*@__PURE__*/_defineComponent({
  __name: 'GamePage',
  setup(__props) {

const saveSlots = useSaveSlots()

let loopId: number | undefined
let running = false

onMounted(() => {
  running = true
  const loop = () => {
    const tick = game.state.tick + 1
    game.emit('tick', { tick })
    saveSlots.autosave()
    if (running) loopId = requestAnimationFrame(loop)
  }
  loopId = requestAnimationFrame(loop)
})

onUnmounted(() => {
  running = false
  if (loopId !== undefined) cancelAnimationFrame(loopId)
})

const itemCount = computed(() =>
  Array.from(game.state.tiles.values()).filter(t => t.item).length,
)

const hoveredItem = computed(
  () => game.ui.state.dragFrom?.item ?? game.ui.state.hovered?.item ?? null,
)

const debugInfo = computed(() => {
  const { hovered, dragFrom, dragOver, activePlan: plan } = game.ui.state

  const summarize = (p: typeof plan) => p && {
    source: p.source.key,
    target: p.target.key,
    item: p.item.uid,
    cluster: p.cluster.map(t => t.key),
    merge: p.merge && {
      consume: p.merge.consume.map(i => i.uid),
      spawn: p.merge.spawn.map(s => `${s.itemId}@${s.tile.key}`),
    },
    explode: p.explode && {
      item: p.explode.item.uid,
      affected: p.explode.affected
        .filter(a => a.damage > 0 || a.tile.shade > 0 || a.tile.shade === 0)
        .map(a => `${a.tile.key} dmg=${a.damage} shade=${a.tile.shade}${a.clears ? ' clears' : ''}`),
    },
    swap: p.swap?.uid ?? null,
  }

  return JSON.stringify({
    mode: dragFrom ? 'drag' : (hovered ? 'inspect' : 'idle'),
    hovered: hovered?.key ?? null,
    dragFrom: dragFrom?.key ?? null,
    dragOver: dragOver?.key ?? null,
    plan: summarize(plan),
    highlight: game.state.highlight,
  }, null, 2)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "m-0 text-2xl" }, "Shade Survival", -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(saveSlots).state.slots, (slot) => {
            return (_openBlock(), _createElementBlock("button", {
              key: slot.id,
              onClick: ($event: any) => (_unref(saveSlots).switch(slot.id)),
              class: _normalizeClass(["px-2 py-1 border rounded text-sm", slot.id === _unref(saveSlots).state.activeSlot
              ? 'bg-slate-900 text-white border-slate-900'
              : 'bg-white text-slate-800 border-slate-300 hover:bg-slate-100']),
              title: slot.hasSave ? `Load save ${slot.id}` : `Start save ${slot.id}`
            }, _toDisplayString(slot.id), 11 /* TEXT, CLASS, PROPS */, _hoisted_5))
          }), 128 /* KEYED_FRAGMENT */)),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(saveSlots).save && _unref(saveSlots).save(...args))),
            class: "px-3 py-1 bg-blue-600 text-white rounded text-sm hover:bg-blue-700",
            title: "Save current slot"
          }, " Save "),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(saveSlots).reset && _unref(saveSlots).reset(...args))),
            class: "px-3 py-1 bg-red-600 text-white rounded text-sm hover:bg-red-700",
            title: "Reset current slot"
          }, " Reset ")
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", null, "Tick: " + _toDisplayString(_unref(game).state.tick), 1 /* TEXT */),
          _createElementVNode("span", null, "Items: " + _toDisplayString(itemCount.value), 1 /* TEXT */)
        ])
      ])
    ]),
    _createVNode(GridPane, { class: "renderer" }),
    _createElementVNode("aside", _hoisted_7, [
      _createVNode(Explainer, {
        plan: _unref(game).ui.state.activePlan,
        "hovered-item": hoveredItem.value
      }, null, 8 /* PROPS */, ["plan", "hovered-item"]),
      _createElementVNode("pre", _hoisted_8, _toDisplayString(debugInfo.value), 1 /* TEXT */)
    ])
  ]))
}
}

})